var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { injectable } from '@servicetitan/react-ioc';
let HistoryManager = class HistoryManager {
    constructor() {
        // Initiator of action, used for filtering redirections
        Object.defineProperty(this, "occupied", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "storage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "register", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (addable) => {
                this.storage.set(addable, addable.listen(location => {
                    const path = addable.createHref(location);
                    const state = location.state;
                    if (!this.occupied) {
                        this.occupied = { history: addable, location };
                    }
                    else if (this.occupied.history === addable) {
                        this.occupied.location = location;
                    }
                    for (const history of this.storage.keys()) {
                        if (history === addable) {
                            continue;
                        }
                        if (history.createHref(history.location) === path &&
                            history.location.state === state) {
                            continue;
                        }
                        // Allow redirects only to the deeper pages
                        const unblock = history.block(location => {
                            if (this.occupied &&
                                !history
                                    .createHref(location)
                                    .startsWith(this.occupied.history.createHref(this.occupied.location))) {
                                return false;
                            }
                        });
                        history.replace(path, state);
                        unblock();
                    }
                    // Wait for all updates, including redirections
                    setTimeout(() => {
                        var _a, _b;
                        if (((_a = this.occupied) === null || _a === void 0 ? void 0 : _a.history) === addable &&
                            ((_b = this.occupied) === null || _b === void 0 ? void 0 : _b.location) === location) {
                            this.occupied = undefined;
                        }
                    });
                }));
            }
        });
        Object.defineProperty(this, "unregister", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (removable) => {
                if (this.storage.has(removable)) {
                    this.storage.get(removable)();
                    this.storage.delete(removable);
                }
            }
        });
    }
};
HistoryManager = __decorate([
    injectable()
], HistoryManager);
export { HistoryManager };
//# sourceMappingURL=history-manager.js.map